// Where a link on the site goes, as an address. A target is { page } | { page, sec } | { page, sec, slug } | { page, sec, set } | { href }
// | { page, sec, video } (validated on the server by apps/portal/link-targets.js). A photo set is addressed as its section's slug "set-<id>",
// a video as "video-<id>".
// window.SiteLinks.href(t) -> "#/portfolio/ux/momsi" ...   .go(t) opens it (new tab for other sites; mailto: / tel: hand over to the app).
(function () {
  const href = t => {
    if (!t) return '';
    if (!t.page) return t.href || '';
    return '#/' + [...(t.page === 'about' ? ['portfolio'] : ['p', t.page]), t.sec, t.slug || (t.set ? `set-${t.set}` : t.video ? `video-${t.video}` : '')].filter(Boolean).join('/');
  };
  const go = t => {
    const h = href(t);
    if (!h) return;
    if (/^https?:/.test(h)) window.open(h, '_blank', 'noopener,noreferrer');
    else if (/^(mailto|tel|sms):/.test(h)) window.location.href = h;
    else window.location.hash = h.startsWith('#') ? h : `#${h}`;
  };
  window.SiteLinks = { href, go };
})();
